module.exports = __webpack_public_path__ + "img/public/siteImages/addIcon.svg?275aafaa";